var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"page-transition"}},[(_vm.isOpen)?_c('div',{staticClass:"fixed inset-0 bg-gray-100 p-8 shadow-xl overflow-y-auto md:left-80 md:shadow-none"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }